import { render, staticRenderFns } from "./NavbarSearch.vue?vue&type=template&id=460bf9db&"
import script from "./NavbarSearch.vue?vue&type=script&lang=js&"
export * from "./NavbarSearch.vue?vue&type=script&lang=js&"
import style0 from "./NavbarSearch.vue?vue&type=style&index=0&id=460bf9db&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports